module.exports = __webpack_public_path__ + "static/27-b05ce39da901a74191c8f3ac20cd329f.jpg";